var lx = lx || {};
lx.gallery = lx.gallery || {};

lx.gallery.switchPhotoList = function (pId, pThis) {
    $(".uploadPhoto-list-tab").hide();
    $("#" + pId).show();
    $(".uploadPhoto-list-select > div").removeClass("uploadPhoto-list-selected");
    $(pThis).addClass("uploadPhoto-list-selected");
    iFrameFullHeight();
}

lx.gallery.iFrameHeight = function (pHeight, pFrameId) {
    var $dialog;
    if (pFrameId) $dialog = $("#" + pFrameId); //#iframe_o
    else $dialog = $(".ui-dialog-content");
    $dialog.height(pHeight).css("max-height", "97vh");

    $dialog = $(".ui-dialog");
    $dialog.css("top", $(window).height() / 2 - $dialog.height() / 2);
}

lx.gallery.iFrameFullHeight = function (pAdd, pFrameId) {
    var vAdd = pAdd;
    if (arguments.length == 0) vAdd = 20;
    var vH = $("body").height() + vAdd;
    parent.iFrameHeight(vH, pFrameId);
}

//Change Folder Picture

lx.gallery.setFldrPic = function (pType, pFid, pCid) {
    $.post(
        'wwv_flow.show', {
            "p_request": 'APPLICATION_PROCESS=setFolderPic',
            "p_flow_id": $v('pFlowId'), //app id
            "p_flow_step_id": $v('pFlowStepId'), //page id
            "p_instance": $v('pInstance'), //session id
            "x01": pType,
            "x02": pFid,
            "x03": pCid
        },
        function (data) {
            //window.parent.iFrameDialogClose(true);
            vItem = 'P' + $v('pFlowStepId') + '_CROP_ID';
            $s(vItem, pCid);
            apex.submit({
                request: 'LOAD_PIC',
                set: {
                    vItem: pCid
                }
            });

        }
    );
}

var switchPhotoList = lx.gallery.switchPhotoList;
var iFrameHeight = lx.gallery.iFrameHeight;
var iFrameFullHeight = lx.gallery.iFrameFullHeight;
var setFldrPic = lx.gallery.setFldrPic;